{
  "en": {
    "task": {
      "actions": {
        "create": "Task",
        "create_and_send": "Create and send",
        "delete": "Delete task",
        "open_in_project": "Open task in project",
        "remove_from_unit": "Remove task from this unit",
        "save_as_draft": "Save as draft",
        "update": "Edit task"
      },
      "attributes": {
        "assignments_count": "Assignments",
        "category": "Completion method",
        "created_at": "Created",
        "description": "Description",
        "title": "Title",
        "units": "Units"
      },
      "categories": {
        "confirmation": "Confirmation",
        "upload": "Document upload"
      },
      "categories_info": {
        "confirmation": "The assignee ticks the task off when it is done.",
        "upload": "The assignee has to upload a document to finish the task."
      },
      "confirm": {
        "delete_body": "The task goes, and so does every assignment under it: {assignments} across {units}.",
        "delete_header": "Delete \"{title}\"?",
        "delete_silent": "Nobody is notified, and notifications that already went out are not taken back.",
        "remove_from_unit_body": "Every assignee of \"{title}\" on {unit} loses it. The task itself and its other units stay as they are.",
        "remove_from_unit_customers": "The customers of {unit} lose it from their portal.",
        "remove_from_unit_header": "Remove this task from {unit}?"
      },
      "filters": {
        "phase_none": "No phase"
      },
      "labels": {
        "assignments_count": "{count} assignment | {count} assignments",
        "created_by": "Created by {name} · {date}",
        "created_on": "Created {date}",
        "no_tasks": "No tasks for this project yet.",
        "required": "This field is required",
        "set_all_assignees": "Set the assignee | Set all {count} assignees",
        "still_to_do": "{count} still to do",
        "units_count": "{count} unit | {count} units",
        "units_required": "Select at least one unit"
      },
      "toasts": {
        "create": "Task created",
        "delete": "Task deleted",
        "remove_from_unit": "Task removed from this unit",
        "update": "Task updated"
      }
    }
  }
}
